<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input-vacancy-multi-select"
        style="width: 140px;"
        size="sm"
        type="text"
        readonly
        :disabled="isDisabled"
        v-model="selectedTitle"
      >
      </b-form-input>
      <b-input-group-append>
        <b-btn size="sm" variant="outline-success" :disabled="isDisabled" @click.stop="showModal">Выбрать</b-btn>
        <b-btn size="sm" variant="secondary" :disabled="isDisabled" @click.stop="onClearSelected"><font-awesome-icon icon="times-circle"/></b-btn>
      </b-input-group-append>
    </b-input-group>

    <b-modal
      id="vacancy-multi-select-modal"
      ref="vacancy_multi_select_modal"
      body-class="modal-body-select"
      title="Вакансии"
      size="xl"
      @close="onCancel"
      scrollable
    >
      <b-navbar id="modal-filters">
        <b-navbar-nav>
          <b-input-group>
            <b-form-input
              id="input-search"
              size="sm"
              v-model="query"
              placeholder="Поиск"
              autocomplete="off"
            />
            <b-input-group-append>
              <b-button size="sm" @click.stop="onClearQuery">
                <font-awesome-icon icon="times-circle"/>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-navbar-nav>
      </b-navbar>

      <b-table
        id="vacancy-multi-select-table"
        ref="vacancy_multi_select_table"
        class="mb-0 table-centered text-small modal-sticky"
        striped
        small
        hover
        responsive
        show-empty
        :empty-text="$t('message.common.emptyTable')"
        :busy.sync="isBusy"
        :items="items"
        :fields="fields"
        @row-clicked="rowClicked"
        :tbody-tr-class="tbodyRowClass"
        no-provider-filtering
        no-provider-paging
        no-provider-sorting
        no-local-sorting
        sticky-header
        head-variant="light"
        @sort-changed="sortChanged"
      />

      <pagination-footer
        :total-rows="totalRows"
        :per-page.sync="perPage"
        @page-click="onPagination"
        @per-page-change="onPerPageChange"
      />

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left">Выбраны: {{ tempSelected.length }}</p>
          <b-button
            variant="primary"
            size="sm"
            class="mr-1 float-right"
            @click="onOk"
          >
            Применить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import helpers from "../../../utilites/helpers";
  import PaginationFooter from "../../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../../utilites/pageSearchService";

export default {
  name: "VacancyMultiSelect",
  components: { PaginationFooter },
  mixins: [
    catalogs,
    helpers, pageSearchService
  ],
  props: {
    title: {type: String, default: "Вакансии"},
    isDisabled: { type: Boolean, default: false },
    initialItems: { type: Array, default: null },
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      query: '',
      items: [],
      selected: [],
      tempSelected: [],
      isBusy: false,
      fields: [
        {
          key: 'id',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true,
        },
      ],
      sortBy: 'id',
      sortDesc: true,
    }
  },
  computed: {
    selectedTitle() {
      if (this.selected.length === 0) {
        return this.title;
      }
      return `${this.title} ${this.selected.length}`;
    },
  },
  methods: {
    async configure(ids) {
      let list = [];
      for (const index in ids) {
        const id = parseInt(ids[index]);
        if (id != null) {
          let item = null;

          if (this.initialItems) {
            item = this.initialItems.find(u => u.id === id);
          }

          if (!item) {
            const result = await this.getVacancyById(id);
            item = result.data;
          }

          if (item != null) {
            list.push(item);
          }
        }
      }
      this.selected = list;
    },
    async showModal() {
      this.tempSelected = [...this.selected];
      this.$refs.vacancy_multi_select_modal.show();
      await this.getItems();
    },
    onClearSelected() {
      this.selected = [];
      this.$emit('onSelect', this.selected);
    },
    onClearQuery() {
      this.query = '';
    },
    onOk() {
      this.selected = [...this.tempSelected];
      this.$emit('onSelect', this.selected);
      this.$refs.vacancy_multi_select_modal.hide();
    },
    onCancel() {
      this.tempSelected = [];
      this.query = '';
    },
    rowClicked(item) {
      // Ищем уже выбранные
      const existItem = this.tempSelected.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.tempSelected.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.tempSelected.push(item);
        this.$set(item, 'selected', true);
      }
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    async getItems() {
      if (this.initialItems) {
        let filteredItems = this.initialItems;

        if (this.query) {
          const lowerQuery = this.query.toLowerCase();
          filteredItems = filteredItems.filter(u =>
            (u.name.toLowerCase().includes(lowerQuery)) ||
            (u.id.toString().includes(this.query))
          );
        }

        this.totalRows = filteredItems.length;
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;

        this.items = filteredItems.slice(start, end);
        this.updateSelected();
        return;
      }

      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query.toLowerCase(),
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      const result = await this.getVacancies(data);

      if (!result || !result.data) {
        this.items = [];
        this.totalRows = 0;
        return;
      }

      this.totalRows = result.data.total;
      this.items = result.data.items;
      this.updateSelected();
    },
    updateSelected() {
      if (!this.items) return;

      this.items.forEach((item) => {
        const isSelected = this.tempSelected.some(e => e.id === item.id);
        this.$set(item, 'selected', isSelected);
      });
    },
  },
  watch: {
    query: {
      async handler() {
        if (this.query) {
          this.currentPage = 1;
          await this.getItems();
        }
      }, deep: true
    },
    value: {
      handler(newIds) {
        if (!newIds) {
          this.selected = [];
          return;
        }

        this.configure(newIds);
      }, deep: true, immediate: true
    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/VacancyMultiSelect.vue